module.exports = __webpack_public_path__ + "media/images/webpage/pages/about/sp-clip-5edff2ab0c99251988bc2146f2f91cfa.webp";